// utils/canvas-utils/is-fabric-image.ts
import { fabric } from 'fabric';

export function isFabricImage(obj: unknown): obj is fabric.Image {
  return !!obj && (obj as fabric.Image).type === 'image';
}
